import { useRef } from "react";
import { Link } from "react-router-dom";
import { DnaSequence } from "./DnaSequence";

export function BioHackAd() {
  const crosshairRef = useRef(null);
  const audioRef = useRef(null);

  const moveCrosshair = (event) => {
    const crosshair = crosshairRef.current;
    if (!crosshair) return;
    const rect = event.currentTarget.getBoundingClientRect();
    crosshair.style.opacity = "1";
    crosshair.style.transform = `translate(${event.clientX - rect.left}px, ${event.clientY - rect.top}px)`;
  };

  const hideCrosshair = () => {
    if (crosshairRef.current) crosshairRef.current.style.opacity = "0";
  };

  const playPulse = () => {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      audioRef.current ||= new AudioContext();
      const context = audioRef.current;
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = "sawtooth";
      oscillator.frequency.setValueAtTime(132, context.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(42, context.currentTime + 0.12);
      gain.gain.setValueAtTime(0.0001, context.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.035, context.currentTime + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.14);
      oscillator.connect(gain).connect(context.destination);
      oscillator.start();
      oscillator.stop(context.currentTime + 0.15);
    } catch {
      // Audio is optional and may be blocked before a user gesture.
    }
  };

  return (
    <section
      className="biohack-ad"
      onMouseMove={moveCrosshair}
      onMouseLeave={hideCrosshair}
      data-testid="biohack-ad-section"
    >
      <div className="biohack-crosshair" ref={crosshairRef} aria-hidden="true" />
      <div className="biohack-frame">
        <div className="biohack-strip">
          <span className="biohack-product" data-testid="biohack-product-tube">
            <DnaSequence compact />
          </span>
          <div className="biohack-copy">
            <span className="biohack-eyebrow">2355 PERFORMANCE SYSTEM // STATUS: OPTIMIZED</span>
            <h2>2355 BIO HACK</h2>
            <h3>The Official Sports Protein in the Tube.</h3>
          </div>
          <Link
            to="/riotball"
            className="biohack-cta"
            onMouseEnter={playPulse}
            data-testid="biohack-cta-button"
          >
            [ INITIATE GENE-LINK // ORDER TUBE ]
          </Link>
        </div>
      </div>
    </section>
  );
}
